/* Small native enhancements. Existing GSAP section animations remain authoritative. */
(() => {
  function init(scope = document) {
    scope.querySelectorAll('.octas-contact__field').forEach(field => {
      const input = field.querySelector('input, select, textarea');
      if (!input || field.querySelector('label')) return;
      const label = document.createElement('label');
      label.htmlFor = input.id;
      label.textContent = input.getAttribute('placeholder') || input.options?.[0]?.textContent.trim() || '';
      field.prepend(label);
    });
    const form = document.querySelector('.octas-contact__form form');
    const selector = form?.querySelector('select[name="contact[Inquiry Type]"]');
    const intents = {partnership: 1, licensing: 2, creator: 3, general: 4};
    function choose(intent, move) {
      if (!selector || !intents[intent]) return;
      selector.selectedIndex = intents[intent];
      selector.dispatchEvent(new Event('change', {bubbles: true}));
      if (move) {
        form.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
        setTimeout(() => form.querySelector('input:not([type="hidden"])')?.focus({preventScroll:true}), 250);
      }
    }
    choose(new URLSearchParams(location.search).get('inquiry'), false);
    document.querySelectorAll('.octas-inquiry-card a[href*="inquiry="]').forEach(link => {
      if (link.dataset.octasBound) return;
      link.dataset.octasBound = 'true';
      link.addEventListener('click', event => {
        if (!selector) return;
        event.preventDefault();
        choose(new URL(link.href).searchParams.get('inquiry'), true);
      });
    });
    scope.querySelectorAll('[id^="OctasFilteredGrid-"]').forEach(grid => {
      if (grid.dataset.redesignBound) return;
      grid.dataset.redesignBound = 'true';
      const filters = [...grid.querySelectorAll('.octas-filtered-grid__filter')];
      const empty = document.createElement('p');
      empty.className = 'octas-filter-empty';
      empty.setAttribute('role', 'status');
      empty.hidden = true;
      empty.textContent = window.octasUI?.emptyCategory || 'No properties are assigned to this category yet. Please try another category.';
      grid.querySelector('.octas-filtered-grid__grid').after(empty);
      function syncFilter() {
        filters.forEach(button => button.setAttribute('aria-pressed', String(button.classList.contains('is-active'))));
        empty.hidden = !!grid.querySelector('.octas-filtered-card:not(.is-hidden)');
      }
      grid.addEventListener('click', syncFilter);
      syncFilter();
    });
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
      document.querySelectorAll('#MainContent video[autoplay]').forEach(video => {
        video.pause();
        video.removeAttribute('autoplay');
        video.addEventListener('loadeddata', () => video.pause(), {once: true});
      });
    }
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => init()) : init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
